module.exports = __webpack_public_path__ + "img/08706145000890.a5a13e56.png";